<script lang="ts" setup>
const props = defineProps<{
    resource: FileResource;
    active?: boolean;
    disabled?: boolean;
    checkbox?: boolean;
    checked?: boolean;
}>();

const emit = defineEmits<{
    (e: 'onSelect', item: FileResource, ev: MouseEvent): void;
}>();

const slots = useSlots();

const getDropdownOptions = inject<any>('getDropdownOptions');
const bindItem = inject<any>('bindItem');

const onCheck = (ev: MouseEvent): void =>
{
    emit('onSelect', props.resource, ev);
};
</script>

<template>
    <button class="resource-wrapper m-0 btn btn-secondary p-2 d-flex flex-column">
        <div class="d-flex align-items-center w-100">
            <!-- Icon -->
            <input
                v-if="checkbox"
                class="form-check-input me-2 mt-0 pointer"
                type="checkbox"
                :checked="checked"
                @click.stop="onCheck"
            >
            <span v-else-if="slots?.icon" class="fs-5 me-2">
                <slot name="icon" />
            </span>

            <!-- Text -->
            <span class="text-truncate" :title="resource.title ?? resource.name">{{ resource.name }}</span>

            <!-- Dropdown -->
            <IdeoDropdown
                :variant="null"
                no-caret
                class="ms-auto"
                size="sm"
                :disabled="disabled"
            >
                <template #button-content>
                    <i class="fas fa-ellipsis-vertical" />
                </template>

                <IdeoDropdownItemButton
                    v-for="item in getDropdownOptions(resource)"
                    :key="item.id"
                    v-lightbox="{ inactive: !resource.isImage }"
                    :tag="item.id === 'download' ? 'a' : 'button'"
                    class="py-2 text-capitalize"
                    v-bind="bindItem(item, resource)"
                    @click.prevent.stop="item.onClick?.()"
                >
                    <i class="icon" :class="item.icon" />
                    <span>{{ item.text }}</span>
                </IdeoDropdownItemButton>
            </IdeoDropdown>
        </div>

        <slot />
    </button>
</template>

<style lang="scss" scoped>
.btn {
    color: var(--bs-gray);
    background: var(--bs-gray-200);
    border-color: var(--bs-gray-200);

    .text-truncate {
        flex: 1;
        text-align: left;
        text-transform: none;
    }
}
</style>

<style lang="scss">
[data-bs-theme=dark] .resource-wrapper {
    &, &:active {
        color: var(--bs-gray-300);
        background: var(--bs-gray-800);
        border-color: var(--bs-gray-800);
    }

    &.active {
        background: var(--bs-gray-200);
        border-color: var(--bs-gray-200);
        color: var(--bs-gray-600);
    }
    .btn {
        color: var(--bs-gray-600);
        border-color: transparent;
    }
}

.resource-wrapper {
    color: var(--bs-gray-600);

    input[type="checkbox"] {
        width: 16.25px;
        height: 16.25px;
    }

    .dropdown {
        &-btn {
            &:disabled,
            &:hover {
                background: none;
                border-color: transparent;
            }
        }
    }

    &.active {
        background: var(--bs-primary-bg-subtle);
        border-color: var(--bs-primary-bg-subtle);
    }
}
</style>
